import request from '@/util/bpmRequest'

/**
 * 分页获取列表
 */
export function listPage(data) {
  return request({
    url: '/history/proc/listPage',
    method: 'post',
    data
  })
}

/**
 * 删除流程定义
 */
export function taskListByProcInstId(data) {
  return request({
    url: '/history/taskListByProcInstId',
    method: 'post',
    data
  })
}

/**
 * 撤销流程
 */
export function revoke(data) {
  return request({
    url: '/history/proc/revoke',
    method: 'post',
    data
  })
}

